import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fda0efb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2fda0efb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda0efb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fda0efb')) {
      api.createRecord('2fda0efb', component.options)
    } else {
      api.reload('2fda0efb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fda0efb&scoped=true", function () {
      api.rerender('2fda0efb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/components/formSetting/index.vue"
export default component.exports